<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <reporting v-if="users!==null&&groups!==null" :poolID="PoolID" :users="users" :groups="groups" :tags="tags" :ClientID="ClientID" :isgroup="false" :hasEmail="hasEmail" :gt="goto"></reporting>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
  import reporting from "../../components/Reporting.vue"

  export default {
    name: 'PoolReporting',
    components: {acheader,acfooter,poolsidebar,reporting},
    data() {
      return {
        goto:null,
        users:null,
        groups:null,
        tags:null,
        PoolID:null,
        hasEmail:null,
        ClientID:null
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.id);

        var tp = localStorage.getItem("tpBypass");
        if (tp==="true") {
           this.goto="tp";
           localStorage.removeItem("tpBypass");
        } 

        this.apiCommand([
           {
             Operation: "LicensePool",
             Function: "GetMembers",
             Fields: {
               LicensePoolID: this.$route.params.id
             }
           },
          {
            Operation: "LicensePool",
            Function: "GetGroups",
            Fields: {
              LicensePoolID: this.$route.params.id
            }
          },
           {
             Operation: "Client",
             Function: "GetClientByID",
             Fields: {
               ClientID: this.udata.ClientID
             }
           },
           {
              Operation: "LicensePool",
              Function: "GetTags",
              Fields: {
                LicensePoolID: this.$route.params.id
              }
           }
        ]).then(r=>{
          var cr=JSON.parse(r.CommandResult);
          var cli = JSON.parse(cr.returnObjects[2].returnObject);
          this.hasEmail=cli.EmailAddress!==null&&cli.EmailAddress.length>0;
          this.ClientID=this.udata.ClientID;
          this.PoolID=this.sdata.activepool.LicensePoolID;
          this.users = JSON.parse(cr.returnObjects[0].returnObject);
          this.groups = JSON.parse(cr.returnObjects[1].returnObject);
          this.tags = JSON.parse(cr.returnObjects[3].returnObject);
        });
      });
    }
  }
</script>
